module.exports = __webpack_public_path__ + "static/media/29EUNOG7.005ce7b5.jpg";